import { render } from "./ChangePassword.vue?vue&type=template&id=3319f272"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/views/ChangePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3319f272"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3319f272', __exports__)) {
    api.reload('3319f272', __exports__)
  }
  
  module.hot.accept("./ChangePassword.vue?vue&type=template&id=3319f272", () => {
    api.rerender('3319f272', render)
  })

}


export default __exports__